import type { Package } from '@/types/api'
import { createCrudService } from '../crud'

export type PackageInput = Pick<
  Package,
  'weight' | 'unit_code' | 'name_en' | 'name_ru' | 'name_uz' | 'name_cyr' | 'status'
>

export const packagesService = createCrudService<Package, PackageInput>('packages')
